import { BannerImagesEditorComponent } from './features/shared/components/avatar-banner/banner-images-editor.component';
import { GamificationModule } from './features/gamification/gamification.module';
import { ProfileRelationshipComponent } from './features/user-profile/components/profile-relationship.component';
import { TeamSnapshotComponent } from './features/shared/components/profile-tabs/team-snapshot.component';
import { ProfileFlipPanelComponent } from './features/shared/components/profile-tabs/profile-flip-panel.component';
import { DropdownModule } from 'primeng/dropdown';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TextFieldModule } from '@angular/cdk/text-field';
import { EditTeamBannerAction, StyleTeamBannerAction } from './features/teams/actions/team-banner.actions';
import { EditProfileBannerAction, StyleProfileBannerAction } from './features/user-profile/actions/profile-banner.actions';
import { BannerEffectComponent } from './features/shared/components/avatar-banner/banner-effect.component';
import { ProfileAvatarBannerComponent } from './features/shared/components/avatar-banner/profile-avatar-banner.component';
import { AppearanceEditorComponent } from './features/shared/components/appearance-editor/appearance-editor.component';
import { AvatarBannerComponent } from './features/shared/components/avatar-banner/avatar-banner.component';
import { FitBannerNameDirective } from './features/shared/components/avatar-banner/fit-banner-name.directive';
import { ProfileTabsComponent } from './features/shared/components/profile-tabs/profile-tabs.component';
import { ProfileContentComponent } from './features/shared/components/profile-tabs/profile-content.component';
import { ProfileSkeletonComponent } from './features/shared/components/profile-tabs/profile-skeleton.component';
import { ProfileActivitiesComponent, ProfileActivityStatsComponent, TeamMembersComponent } from './features/shared/components/profile-tabs/profile-widgets.components';
import { CommonModule } from '@angular/common';
import { AppAsideModule } from '@coreui/angular';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AgGridModule } from 'ag-grid-angular';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgbPopoverModule, NgbTooltipModule, NgbModalModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CENTRAL_COMPONENTS } from './features/streaker-central/streaker-central.module';
import { FitnessUserProfileComponent } from './features/user-profile/fitness-user-profile.component';
import { ParticipantProfileComponent } from './features/user-profile/participant-profile.component';
import { ProfileFriendsComponent, ProfileFriendPickerComponent } from './features/user-profile/components/profile-friends/profile-friends.component';
import { ProductMediaGalleryComponent } from './features/product-media/product-media-gallery.component';
import { RecipientPhotoGalleryComponent } from './features/recipients/components/recipient-photo-gallery.component';
import { RecipientCardsComponent } from './features/recipients/components/recipient-cards.component';
import { RecipientsPageComponent } from './features/recipients/components/recipients-page.component';
import { RecipientDetailComponent } from './features/recipients/components/recipient-detail.component';
import { RecipientStoryBodyComponent } from './features/recipients/components/recipient-story-body.component';
import { RecipientLoadingSkeletonComponent } from './features/recipients/components/recipient-loading-skeleton.component';
import { RecipientPreviewComponent } from './features/recipients/components/recipient-preview.component';
import { SeasonBannerComponent } from './features/shared/components/season-banner/season-banner.component';
import { FitnessMediaImageComponent } from './features/shared/components/fitness-media-image/fitness-media-image.component';
import { ProductImagePreviewComponent } from './features/shared/components/product-image-preview/product-image-preview.component';
import { createFitnessProfilePreferences, FITNESS_PROFILE_CONFIG_KEY } from './features/user-profile/user-profile.config';
import { ChartModule } from 'primeng/chart';

import { AppRoutingModule } from './app-routing.module';

import {
  DevwareCoreModule,
  DevwareOrmModule,
  DevwareUIModule,
  DevwareAGGridModule,
  DevwareUILayoutModule,
  DevwareUIMetaDataModule,
  DevwareAdminModule,
  DevwareUiWizardModule,
  DevwareMediaModule,
  DwMenuProcessorToken,
  DwUserContextDynamicHandlerToken,
  DwUiConfigRegistryService,
} from '@devwareapps/devware-cap';

import { AppDevwareConfigProviderService } from './app-devware-config-provider.service';
import { FitnessMenuProcessorService } from './app-menu-processor.service';

import { AppComponent } from './app.component';
import { StreakersLayoutComponent } from './features/layout/streakers-layout.component';
import { StreakersOfflineStateComponent, StreakersSecurityStateComponent, StreakersUpdateNoticeComponent } from './features/layout/streakers-state.components';
import { StreakersNavigationComponent } from './features/layout/streakers-navigation.component';
import { HomeComponent } from './features/shared/pages/home/home.component';
import { FitnessLoginComponent } from './features/shared/pages/login/fitness-login.component';
import { ChallengeRegistrationComponent } from './features/shared/pages/challenge-registration/challenge-registration.component';
import { DonationPreferencesComponent } from './features/user-profile/components/donation-preferences.component';
import { FitnessStoreComponent } from './features/shared/pages/store/store.component';
import { ProductSelectionComponent } from './features/commerce/components/product-selection/product-selection.component';
import { OrderSummaryComponent } from './features/commerce/components/order-summary/order-summary.component';
import { CardPaymentComponent } from './features/commerce/components/card-payment/card-payment.component';
import { FitnessCheckoutComponent } from './features/commerce/components/checkout/fitness-checkout.component';
import { FitnessCheckoutPageComponent } from './features/commerce/components/checkout/fitness-checkout-page.component';

// Shared components
import { UsreAvatarComponent } from './features/shared/components/user-avatar/usre-avatar.component';
import { DateTimeDisplayControlComponent } from './features/shared/components/date-time-display-control/date-time-display-control.component';
import { DateTimeDisplayFormControlComponent } from './features/shared/components/date-time-display-form-control/date-time-display-form-control.component';
import { DurationControlComponent } from './features/shared/components/duration-control/duration-control.component';
import { DurationDisplayControlComponent } from './features/shared/components/duration-display-control/duration-display-control.component';
import { EmailDisplayComponent } from './features/shared/components/email-display/email-display.component';
import { DwFormDebugLogComponent } from './features/shared/components/dw-form-debug-log/dw-form-debug-log.component';
import { GenericTagFiltersComponent } from './features/shared/components/generic-tag-filters/generic-tag-filters.component';
import { DividerMenuComponent } from './features/shared/components/divider-menu/divider-menu.component';
import { UserTypeMenuComponent } from './features/shared/components/user-type-menu/user-type-menu.component';
import { PlaceholderMenuComponent } from './features/shared/components/placeholder-menu/placeholder-menu.component';
import { UserTypeSelectionModalComponent } from './features/shared/components/user-type-selection-modal/user-type-selection-modal.component';

// z-devware components
import { DwTaskContainerComponent } from './features/z-devware/tasks/components/dw-task-container/dw-task-container.component';
import { DwMiniTileComponent } from './features/z-devware/visualizations/components/dw-mini-tile/dw-mini-tile.component';
import { DwChartTileComponent } from './features/z-devware/visualizations/components/dw-chart-tile/dw-chart-tile.component';

// Shared services
import { FitnessUserContextCustomizerService } from './features/shared/contexts/fitness-user-context-customizer.service';
import { FitnessHttpInterceptor } from './features/shared/http-interceptors/fitness-http-interceptor.service';

// Shared column renderers
import { DurationSecondsColumnRendererService } from './features/shared/columns/duration-seconds-column-renderer.service';

// Shared actions
import { ChangeUserTypeActionService } from './features/shared/actions/change-user-type-action.service';
import { ToggleBannerAnimationsAction } from './features/shared/actions/toggle-banner-animations.action';
import { MyOrdersAction } from './features/shared/actions/my-orders.action';
import { FitnessOrdersComponent } from './features/commerce/components/orders/fitness-orders.component';
import { MyProfileAction } from './features/shared/actions/my-profile.action';
import { CreateChallengeActionService } from './features/challenge-admin/create-challenge.action';
import { ReprocessChallengeActionService } from './features/challenge-admin/reprocess-challenge.action';
import { ReprocessChallengeModalComponent } from './features/challenge-admin/reprocess-challenge-modal.component';
import { CreateChallengeModalComponent } from './features/challenge-admin/create-challenge-modal.component';
import { CleanupTestRegistrationsActionService } from './features/challenge-admin/cleanup-test-registrations.action';
import { CleanupTestRegistrationsModalComponent } from './features/challenge-admin/cleanup-test-registrations-modal.component';

// Shared contexts
import { UrlParameterContextService } from './features/shared/contexts/url-parameter-context/url-parameter-context.service';
import { ChallengeContextService } from './features/shared/contexts/challenge-context/challenge-context.service';
import { CurrentChallengeContextService } from './features/shared/contexts/current-challenge-context/current-challenge-context.service';

// Shared challenge selector
import { ChallengeSelectorComponent } from './features/shared/components/challenge-selector/challenge-selector.component';

// Teams feature components (ad-hoc only — pages/routing handled by CAP configuration)
import { TeamCardComponent } from './features/teams/components/team-card/team-card.component';
import { TeamProfileComponent } from './features/teams/components/team-profile/team-profile.component';
import { TeamDiscoveryComponent } from './features/teams/components/team-discovery/team-discovery.component';
import { TeamLeaderboardComponent } from './features/teams/components/team-leaderboard/team-leaderboard.component';
import { CaptainApprovalsComponent } from './features/teams/components/captain-approvals/captain-approvals.component';
import { TeamActivityFeedComponent } from './features/teams/components/team-activity-feed/team-activity-feed.component';
import { TeamJoinCtaComponent } from './features/teams/components/team-join-cta/team-join-cta.component';
import { TeamJoinedModalComponent } from './features/teams/components/team-join-cta/team-joined-modal.component';

// Teams feature actions
import { ApproveJoinRequestActionService } from './features/teams/actions/approve-join-request.action';
import { RejectJoinRequestActionService } from './features/teams/actions/reject-join-request.action';

// Retain CAP metadata-created components when Angular omits development module scopes.
const FITNESS_COMPONENTS = [
    ...CENTRAL_COMPONENTS, ProfileTabsComponent, ProfileContentComponent, ProfileSkeletonComponent, TeamSnapshotComponent, ProfileActivitiesComponent, ProfileActivityStatsComponent, TeamMembersComponent,
    FitnessUserProfileComponent, ParticipantProfileComponent,
    ProfileFriendsComponent, ProfileFriendPickerComponent,
    ProductMediaGalleryComponent,
    RecipientPhotoGalleryComponent,
    RecipientCardsComponent,
    RecipientsPageComponent,
    RecipientDetailComponent,
    RecipientStoryBodyComponent,
    RecipientLoadingSkeletonComponent,
    RecipientPreviewComponent,
    SeasonBannerComponent,
    FitnessMediaImageComponent, ProfileRelationshipComponent,
    ProductImagePreviewComponent,
    AppComponent,
    StreakersLayoutComponent,
    StreakersOfflineStateComponent,
    StreakersSecurityStateComponent,
    StreakersUpdateNoticeComponent,
    StreakersNavigationComponent,
    CreateChallengeModalComponent,
    ReprocessChallengeModalComponent,
    CleanupTestRegistrationsModalComponent,
    HomeComponent,
    FitnessLoginComponent,
    ChallengeRegistrationComponent,
    DonationPreferencesComponent,
    FitnessStoreComponent,
    FitnessOrdersComponent,
    ProductSelectionComponent,
    OrderSummaryComponent,
    CardPaymentComponent,
    FitnessCheckoutComponent,
    FitnessCheckoutPageComponent,

    // Shared infrastructure components
    UsreAvatarComponent,
    DateTimeDisplayControlComponent,
    DateTimeDisplayFormControlComponent,
    DurationControlComponent,
    DurationDisplayControlComponent,
    EmailDisplayComponent,
    DwFormDebugLogComponent,
    GenericTagFiltersComponent,
    DividerMenuComponent,
    UserTypeMenuComponent,
    PlaceholderMenuComponent,
    UserTypeSelectionModalComponent,

    // z-devware components
    DwTaskContainerComponent,
    DwMiniTileComponent,
    DwChartTileComponent,

    // Challenge selector (shared)
    ChallengeSelectorComponent,

    // Teams feature (ad-hoc components only)
    BannerImagesEditorComponent, TeamCardComponent, ProfileFlipPanelComponent, BannerEffectComponent, AvatarBannerComponent, FitBannerNameDirective, ProfileAvatarBannerComponent, AppearanceEditorComponent,
    TeamProfileComponent,
    TeamDiscoveryComponent,
    TeamLeaderboardComponent,
    CaptainApprovalsComponent,
    TeamActivityFeedComponent,
    TeamJoinCtaComponent,
    TeamJoinedModalComponent,
  ];

@NgModule({
  declarations: FITNESS_COMPONENTS,
  imports: [
    BrowserModule, GamificationModule,
    BrowserAnimationsModule,
    CommonModule,
    AppAsideModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AgGridModule.forRoot(),
    BsDropdownModule.forRoot(),
    NgbPopoverModule, NgbTooltipModule,
    NgbModalModule,
    NgbDropdownModule, DropdownModule, OverlayPanelModule, TextFieldModule,
    ChartModule,

    DevwareCoreModule,
    DevwareOrmModule,
    DevwareUIModule,
    DevwareAGGridModule,
    DevwareUILayoutModule,
    DevwareUIMetaDataModule,
    DevwareUiWizardModule,
    DevwareAdminModule,
    DevwareMediaModule,

    AppRoutingModule,
  ],
  providers: [
    { provide: 'FITNESS_COMPONENT_REGISTRATION', useValue: FITNESS_COMPONENTS },
    AppDevwareConfigProviderService,
    {
      provide: DwUserContextDynamicHandlerToken,
      useClass: FitnessUserContextCustomizerService,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FitnessHttpInterceptor,
      multi: true,
    },
    {
      provide: DwMenuProcessorToken,
      useClass: FitnessMenuProcessorService,
      multi: true,
    },

    // Global column renderers
    DurationSecondsColumnRendererService,

    // Global actions
    EditTeamBannerAction, StyleTeamBannerAction,
    EditProfileBannerAction, StyleProfileBannerAction,
    ChangeUserTypeActionService,
    ToggleBannerAnimationsAction,
    MyProfileAction,
    MyOrdersAction,
    CreateChallengeActionService,
    ReprocessChallengeActionService,
    CleanupTestRegistrationsActionService,
    ApproveJoinRequestActionService,
    RejectJoinRequestActionService,

    // Global contexts
    UrlParameterContextService,
    ChallengeContextService,
    CurrentChallengeContextService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(registry: DwUiConfigRegistryService) {
    registry.registerConfig(FITNESS_PROFILE_CONFIG_KEY, createFitnessProfilePreferences());
    registry.registerConfig('dw_User-fitness-account-profile', createFitnessProfilePreferences(true));
  }
}
